import { render, staticRenderFns } from "./ContentTitleBlock.vue?vue&type=template&id=4831b0e4&scoped=true&"
import script from "./ContentTitleBlock.vue?vue&type=script&lang=js&"
export * from "./ContentTitleBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContentTitleBlock.vue?vue&type=style&index=0&id=4831b0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831b0e4",
  null
  
)

export default component.exports